import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/cuero")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Cuero, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Cuero & DeWitt County. Free quotes — +1 (830) 390-9588.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Cuero, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Cuero and DeWitt County.",
      keywords: "awnings Cuero, awning company Cuero, custom awnings Cuero, sail shades Cuero, patio covers Cuero, pergola covers Cuero, metal awnings Cuero, canvas awnings Cuero, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Cuero", "DeWitt County"),
  }),
  component: () => <CityHomePage city="Cuero" region="DeWitt County" />,
});
